// Central icon component — uses lucide-react (inline SVG, no external font/CDN).
// Components reference icons by semantic name via <Icon name="trophy" />.
// Any unknown name falls back to a neutral dot so the UI never breaks.

import React from "react";
import {
  Zap, Rocket, Lightbulb, Flag, Ruler, Settings, BookOpen, Microscope, Wrench,
  Mic, CloudRain, Megaphone, MessageSquare, Users, ClipboardCheck, Calendar,
  Shuffle, SlidersHorizontal, Building2, ShieldCheck, ArrowLeft, ArrowRight,
  ArrowLeftRight, Trophy, AlertTriangle, Compass, BarChart3, Brain, UserSearch,
  UserX, CheckCircle2, XCircle, Anchor, FileText, Copy, Target, Search, User,
  Plus, Replace, TrendingUp, TrendingDown, Minus, CircleCheck, Download, DollarSign,
  UserPlus, ChevronsUp, ChevronsDown, X, Lock, Unlock, Maximize2, ChevronDown, ChevronRight,
} from "lucide-react";

const MAP = {
  // Archetype icons
  bolt: Zap,
  rocket: Rocket,
  bulb: Lightbulb,
  flag: Flag,
  ruler: Ruler,
  settings: Settings,
  book: BookOpen,
  microscope: Microscope,
  tools: Wrench,
  microphone: Mic,
  "cloud-rain": CloudRain,
  speakerphone: Megaphone,
  messages: MessageSquare,
  users: Users,
  "clipboard-check": ClipboardCheck,
  calendar: Calendar,
  shuffle: Shuffle,
  sliders: SlidersHorizontal,
  building: Building2,
  shield: ShieldCheck,
  // UI icons
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-swap": ArrowLeftRight,
  trophy: Trophy,
  alert: AlertTriangle,
  compass: Compass,
  chart: BarChart3,
  brain: Brain,
  "user-search": UserSearch,
  "user-x": UserX,
  check: CheckCircle2,
  "circle-check": CircleCheck,
  "x-circle": XCircle,
  anchor: Anchor,
  file: FileText,
  "file-text": FileText,
  "user-plus": UserPlus,
  "chevrons-up": ChevronsUp,
  "chevrons-down": ChevronsDown,
  "chevron-down": ChevronDown,
  "chevron-right": ChevronRight,
  maximize: Maximize2,
  x: X,
  copy: Copy,
  target: Target,
  search: Search,
  user: User,
  plus: Plus,
  replace: Replace,
  up: TrendingUp,
  down: TrendingDown,
  flat: Minus,
  download: Download,
  dollar: DollarSign,
  lock: Lock,
  unlock: Unlock,
};

export default function Icon({ name, size = 18, className = "", style = {}, strokeWidth = 2 }) {
  const Cmp = MAP[name] || User;
  return <Cmp size={size} className={className} style={style} strokeWidth={strokeWidth} />;
}
